import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InternalStack } from "./internal/InternalStack.js";
const Stack = /*#__PURE__*/ forwardRef(({ as, ...props }, ref)=>/*#__PURE__*/ jsx(InternalStack, {
        as: as,
        ref: ref,
        ...props
    }));
Stack.displayName = 'Stack';
export { Stack };
